import { setLocale, addMethod, mixed } from "yup"
import { esConfig } from "./yup.configEs"

setLocale(esConfig)

// eslint-disable-next-line func-names
addMethod(mixed, "maxDecimals", function (message, decimal = 2) {
  return this.test(
    "max-decimals",
    message ?? `Solo se aceptan valores con ${decimal} decimales`,
    value => new RegExp(`^(-)?([0-9]+(.|,)?[0-9]{0,${decimal}})$`).test(value)
  )
})
